import { Plugin, PluginKey } from "prosemirror-state";
import {
  dismissSlashMenuForBackspace,
  syncSlashDismissState,
} from "./slashCommandItems.js";

export function createSlashDismissSyncPlugin() {
  return new Plugin({
    key: new PluginKey("slashDismissSync"),
    props: {
      handleKeyDown(view, event) {
        if (event.key !== "Backspace") {
          return false;
        }

        dismissSlashMenuForBackspace(view.state);
        return false;
      },
    },
    appendTransaction(transactions, oldState, newState) {
      if (!transactions.some((transaction) => transaction.docChanged)) {
        return null;
      }

      syncSlashDismissState(newState, oldState);
      return null;
    },
  });
}
